export default __webpack_public_path__ + "static/media/firebase-seeklogo.com.a0224bb3.svg";